import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'rcp-progress-bar',
  template: `
    <div class="progress-bar">
      @if (typeof progress() === 'number') {
        <div class="progress-bar__inner" [class.positive]="usePositiveColor()" [style.width]="progress() + '%'"></div>
      } @else {
        <div class="progress-bar__loader"></div>
      }
    </div>
  `,
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProgressBarComponent {
  readonly progress = input<number>();
  readonly usePositiveColorWhenFull = input(false);
  readonly color = input<'default' | 'positive'>('default');

  readonly usePositiveColor = computed(
    () => this.color() === 'positive' || (this.progress() === 100 && this.usePositiveColorWhenFull()),
  );
}
